import React from "react";
import UserDetails from "../../components/UserDetails/UserDetails";

const UserDetailsLayer = ({ user }) => {
    return (
        <div className="w-full max-w-full rounded-2xl border border-white/10 bg-white/[0.03] p-1 text-white backdrop-blur-sm">
            <UserDetails user={user} />
        </div>
    );
};

export default UserDetailsLayer;
